 <template>
  <div class="writeOffMuseum">
  	<div class="title">票务核销</div>
    <div class="itemCard">
      <div class="lineContent">
        <div class="name">手机号</div>
        <el-input v-model="data.phone" placeholder="请输入预约登录手机号" maxlength="11"></el-input>
      </div>
      <div class="tips">温馨提示：个人预约请填写该人员对应手机号<br/>
      团队预约请填写团队负责人的手机号</div>
    </div>
    <div class="buttonNormal" @click="check">立即核销</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
      	phone: ''
      },
      ticketId: ''
    };
  },

  props: ['team', 'showAddNewGroup'],

  methods: {
    check() {
    	this.data.museumCode = this.$route.query.museumCode
      this.data.ticketId = (this.$route.query.ticketId || this.ticketId).toString()
      this.$store.state.writePhone = this.data.phone
    	this.$ajax.put(`/api/ticket/front/order/user-write-off`, this.data).then((res) => {
        if (res.rel) {
          return this.$router.push(`/ticket/re_success?museumCode=${this.$route.query.museumCode}&orderId=${res.data}&resType=1`)
        }
        alert(res.data)
    	})
    },

    getticketDetail() {
      this.$ajax.get(`/api/ticket/front/ticket-info?museumCode=${this.$store.state.museumCode}${this.$route.query.ticketId ? `&ticketInfoId=${this.$route.query.ticketId}` : ''}`).then((res) => {
        this.ticketId = res.data[0].id
        document.title = res.data[0].ticketName
      })
    },
  },

  created() {
    this.$store.state.museumCode = this.$route.query.museumCode
    if (this.$route.query.ticketId) return
    this.getticketDetail()
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .writeOffMuseum{
    .title{
    	font-size: 0.5rem;
    	margin-top: 1rem;
    	font-weight: 500;
    }
    .tips{
    	margin-top: 0.5rem;
    	font-size: 0.3rem;
    	text-align: left;
    	line-height: 0.6rem;
    }
  }
</style>
